import { useGetDataTemplatesQuery } from "@/redux/service";

import { DataTemplateResponse } from "@/redux/datablocks/types";
import { useMemo } from "react";

export const useEvidenceTemplates = () => {
  const { data: templates } = useGetDataTemplatesQuery({
    pagination: "off",
    isEvidence: true,
  }) as { data: DataTemplateResponse[] | undefined };
  return templates;
};

export const useEnabledEvidenceTemplates = (templateIds?: number[]) => {
  const templates = useEvidenceTemplates();

  return useMemo(() => {
    if (templates == null) return;

    return templates.filter(
      (i) =>
        !i.disabled &&
        (templateIds && templateIds.length > 0
          ? templateIds.includes(i.id)
          : true),
    );
  }, [templates, templateIds]);
};

export const useDisabledEvidenceTemplates = () => {
  const templates = useEvidenceTemplates();

  return useMemo(() => {
    if (templates == null) return;

    return templates.filter((i) => i.disabled);
  }, [templates]);
};
